import { useDynamicEntity } from './useDynamicEntity';
import { useAuth } from './index';

const usePartners = () => {
  const { user } = useAuth();
  const dynamicHook = useDynamicEntity({
    entityType: 'partners',
    gqlEntityKey: 'partners',
    queryName: 'GET_PARTNERS_QUERY',
    createMutation: 'CREATE_PARTNER_MUTATION',
    updateMutation: 'UPDATE_PARTNER_MUTATION',
    deleteMutation: 'DELETE_PARTNER_MUTATION',
    updateVariableName: 'set',
    transformData: (partner) => ({
      ...partner,
      company_name: partner.company?.name || `Company ${partner.company_id}`,
      partner_name: partner.partner_name,
      partner_description: partner.partner_description,
      partner_status: partner.partner_status ? 'active' : 'inactive',
      companyId: partner.company_id,
    }),
    transformFormData: (formData) => ({
      partner_name: formData.partner_name,
      partner_description: formData.partner_description || null,
      partner_status: formData.partner_status === 'active',
      company_id: formData.companyId,
    }),
    customWhereCondition: user?.role === 'ROOT' ? {} : { company_id: { _eq: user?.companyId } },
  });
  return {
    ...dynamicHook,
    isRootUser: user?.role === 'ROOT',
  };
};

export { usePartners }; 